export default __webpack_public_path__ + "static/media/totalSections.3946ab9c.svg";